import { CaseListType, useOptionsStore } from "@/App/options/options.store";
import { useRouter } from "vue-router";
import { useCasesStore } from "@/Pages/Cases/store";
import { computed } from "vue";
import { twiageRouter } from "@/App/router/router";

type UseCaseNavBarOptions = { onSaveMap: () => void; onSaveCaseListType: (event: Event) => void };
export const useCaseNavBarOptions = (): UseCaseNavBarOptions => {
  const optionsStore = useOptionsStore();
  const router = useRouter();
  const casesStore = useCasesStore();

  const showMap = computed(() => optionsStore.showCaseMap);

  const onSaveCaseListType: UseCaseNavBarOptions["onSaveCaseListType"] = (event) => {
    const eventTarget = event.target as HTMLInputElement;
    if (parseInt(eventTarget?.value) === CaseListType.Map) {
      router.push(twiageRouter.caseListPath());
      casesStore.setSelectedCaseId({ caseId: null });
    }
    optionsStore.setCasesListType(parseInt(eventTarget?.value));
  };
  const onSaveMap = (): void => {
    optionsStore.setCaseMapVisibility(showMap.value);
    if (showMap.value) optionsStore.setCondensedCaseDetail(false);
  };

  return {
    onSaveCaseListType,
    onSaveMap,
  };
};
